export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";